import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './processoLogisticaForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaVencido, getListaUnidade, getListaTipo
} from './processoLogisticaActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import consts from '../consts';

class ProcessoLogistica extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaVencido();
		this.props.getListaUnidade();
		this.props.getListaTipo();
	}
	
	componentWillUnmount() {
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const usuarioBase = !this.props.usuarioCarregado || this.props.usuarioCarregado.id_unidade;
	
		return (
			<ContentCard>
				<ContentCardHeader>
					
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										data_realizacao: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()), 
										id_unidade: this.props.usuarioCarregado.id_unidade || null 
									});
								}} />
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					{!usuarioBase &&
					<Row>
						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 6 6'
							placeholder='Selecione o unidade'
							value={this.state.id_unidade}
							onChange={value => this.setState({ ...this.state, id_unidade: value })} />

					<Select
							options={this.props.listaTipo}
							label='Tipo'
							cols='12 6 6 6'
							placeholder='Selecione o tipo'
							value={this.state.id_tipo}
							onChange={value => this.setState({ ...this.state, id_tipo: value })} />

					</Row>}
					
					{!usuarioBase &&
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />}
					
					{this.props.listaVencido.length > 0 &&
					<Table responsive>
						<THead>
							<Tr>
								{!usuarioBase &&
								<Th alignCenter>Unidade</Th>}
								<Th alignCenter>Tipo</Th>
								<Th alignCenter>Frequência</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.listaVencido).filter(item => {
								if (this.state.id_unidade && item.id_unidade != this.state.id_unidade) {
									return false;
								}
								if (this.state.id_tipo && item.id_tipo != this.state.id_tipo) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} 
									backgroundColor='#1b61ac' >
									{!usuarioBase &&
									<Td alignCenter bold color='#ffffff'>{item.nome_unidade}</Td>}
									<Td alignCenter bold color='#ffffff'>{item.nome_tipo}</Td>
									<Td alignCenter bold color='#ffffff'>{item.dias == 1 ? 'Diário' : (item.dias == 7 ? 'Semanal' : (item.dias == 30 ? 'Mensal' : `A cada ${item.dias} dias`))}</Td>
									<Td alignRight minWidth={10}>
										<button 
											type='button'
											class='btn btn-flat btn-success' 
											onClick={() => {
												this.props.setModoTela('cadastro', {
													id_unidade: item.id_unidade,
													id_tipo: item.id_tipo,
													data_realizacao: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
												});
												this.props.initForm({
													id_unidade: item.id_unidade,
													id_tipo: item.id_tipo,
													data_realizacao: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
												});
											}}><i class='fas fa-play'></i></button>
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>}

					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Data</Th>
								{!usuarioBase &&
								<Th alignCenter>Unidade</Th>}
								<Th alignCenter>Tipo</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${DateFormat.formatarDataSqlParaTela(item.data_realizacao)}  ${item.nome_unidade || ''} ${item.observacao || ''} ${item.nome_tipo || ''} ${item.nome_usuario || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								if (this.state.id_unidade && item.id_unidade != this.state.id_unidade) {
									return false;
								}
								if (this.state.id_tipo && item.id_tipo != this.state.id_tipo) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id}>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_realizacao)}</Td>
									{!usuarioBase &&
									<Td alignCenter>{item.nome_unidade}</Td>}
									<Td alignCenter>{item.nome_tipo}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={true}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													data_realizacao: DateFormat.formatarDataSqlParaTela(item.data_realizacao)
												});
												this.props.initForm({
													...item,
													data_realizacao: DateFormat.formatarDataSqlParaTela(item.data_realizacao)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={true}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													data_realizacao: DateFormat.formatarDataSqlParaTela(item.data_realizacao)
												});
												this.props.initForm({
													...item,
													data_realizacao: DateFormat.formatarDataSqlParaTela(item.data_realizacao)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.processoLogistica.modoTela,
	lista: state.processoLogistica.lista.filter(item => {
		if (!state.auth.usuarioCarregado) {
			return false;
		} else if (state.auth.usuarioCarregado.id_unidade) {
			return item.id_unidade == state.auth.usuarioCarregado.id_unidade;
		} else {
			return true;
		}
	}),
	listaVencido: state.processoLogistica.listaVencido.filter(item => {
		if (!state.auth.usuarioCarregado) {
			return false;
		} else if (state.auth.usuarioCarregado && state.auth.usuarioCarregado.id_unidade) {
			return item.id_unidade == state.auth.usuarioCarregado.id_unidade;
		} else {
			return true;
		}
	}),
	listaUnidade: state.processoLogistica.listaUnidade.filter(item => !item.valor.includes('DIRETA')).filter(item => {
		if (!state.auth.usuarioCarregado) {
			return false;
		} else if (state.auth.usuarioCarregado && state.auth.usuarioCarregado.id_unidade) {
			return item.id == state.auth.usuarioCarregado.id_unidade;
		} else {
			return true;
		}
	}),
    listaTipo: state.processoLogistica.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaVencido, getListaUnidade, getListaTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ProcessoLogistica);
